<template>
  <v-dialog v-model="dialog" scrollable max-width="500">
    <v-card>
      <v-card-title>
        {{ challengeGoalTitle }}編集
        <v-spacer />
        <IconButton icon="mdi-close" @click="cancel" />
      </v-card-title>

      <v-card-text>
        <v-form ref="chg_form">
          <v-container>
            <v-row>
              <v-col cols="6" class="pa-0">
                <v-select
                  label="表示順"
                  v-model="groupSelect"
                  item-text="label"
                  item-value="value"
                  :items="groupSelects"
                  return-object
                />
              </v-col>
              <v-col cols="12" class="pt-0 pb-0 pl-1 pr-0"
                >チャレンジ目標</v-col
              >
              <v-col cols="12" class="pa-0">
                <quillEditor
                  ref="myQuillEditor2"
                  v-model="chgGoalContent"
                  :options="editorOption"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="pt-5 pb-0 pl-0 pr-0">
                <FormInputComponent
                  label="目標数"
                  type="number"
                  v-model="chgGoalGoalVal"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="pa-0">
                <FormInputComponent
                  label="ウェイト"
                  type="number"
                  v-model="chgGoalWeight"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <Button @click="erntry_confirm" color="primary">登録</Button>
              </v-col>
              <v-col>
                <Button
                  v-if="isDeleteBtn"
                  @click="delete_confirm"
                  color="danger"
                  >削除</Button
                >
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <ConfirmDialog
          ref="confirm"
          :title="challengeGoalTitleMsg"
          :message="confirmMessage"
          buttonMessage="OK"
          @confirm="editEvaluationInfo"
        >
        </ConfirmDialog>
        <DialogMessage ref="dialog" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';
import axios from 'axios';
import config from '../../../const.js';
import message from '../../../message.js';
import moment from 'moment';
import { getSessionStorageItem } from '../../../common.js';

export default {
  components: {
    quillEditor,
    ConfirmDialog,
  },
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    deleteFlg: false,
    groupId: 0,
    confirmMessage: null,
    challengeGoalTitle: '',
    challengeGoalTitleMsg: '',

    goalId: '',
    gradeId: '',
    challengeGoalGuide: '',
    chgGoalContent: '',
    chgGoalGoalVal: '',
    chgGoalWeight: '',
    updateFlg: true,
    isDeleteBtn: false,
    editorOption: {
      theme: 'snow',
      modules: {
        toolbar: [
          { color: ['red', 'blue', 'deeppink'] },
          'bold',
          'underline',
          'clean',
        ],
      },
      placeholder: 'チャレンジ目標を入力してください。',
    },

    groupSelect: { value: '', label: '' },
    groupSelects: [
      { value: 1, label: config.GOAL_NO_STR + '1' },
      { value: 2, label: config.GOAL_NO_STR + '2' },
      { value: 3, label: config.GOAL_NO_STR + '3' },
      { value: 4, label: config.GOAL_NO_STR + '4' },
    ],

    // チャレンジ目標情報
    chgGoal1Content: '',
    chgGoal1GoalVal: 0,
    chgGoal1Wekght: 0,
    chgGoal2Content: '',
    chgGoal2GoalVal: 0,
    chgGoal2Wekght: 0,
    chgGoal3Content: '',
    chgGoal3GoalVal: 0,
    chgGoal3Wekght: 0,
    chgGoal4Content: '',
    chgGoal4GoalVal: 0,
    chgGoal4Wekght: 0,
  }),

  methods: {
    open(
      goalId,
      gradeId,
      groupId,
      chgGoalContent,
      chgGoalGoalVal,
      chgGoalWeight,
      updateFlg,
      challengeGoalTitle
    ) {
      // 初期化
      this.goalId = goalId;
      this.groupSelect = { label: '', value: '' };
      this.gradeId = gradeId;
      this.dialog = true;
      this.updateFlg = updateFlg;

      this.challengeGoalTitle = challengeGoalTitle;
      this.challengeGoalTitleMsg = challengeGoalTitle + config.MESSAGE_EDIT;

      if (updateFlg) {
        this.isDeleteBtn = true;
      } else {
        this.isDeleteBtn = false;
      }

      this.groupId = groupId;
      this.chgGoalContent = chgGoalContent;
      this.chgGoalGoalVal = chgGoalGoalVal;
      this.chgGoalWeight = chgGoalWeight;

      this.groupSelect.value = groupId;
      this.groupSelect.label = config.GOAL_NO_STR + String(groupId);

      // 評価情報取得
      this.getEvaluationItem();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    erntry_confirm() {
      // 入力チェック
      if (!this.$refs.chg_form.validate()) {
        return;
      }
      // チャレンジ目標(必須)
      if (!this.chgGoalContent) {
        this.$refs.dialog.open(
          'info',
          'チャレンジ目標が入力されていません。チャレンジ目標を入力して下さい。'
        );
        return;
      }
      // 目標数(必須)
      if (!this.chgGoalGoalVal) {
        this.$refs.dialog.open(
          'info',
          '目標数が入力されていません。目標数を入力して下さい。'
        );
        return;
      }
      // ウェイト(必須)
      if (!this.chgGoalWeight) {
        this.$refs.dialog.open(
          'info',
          'ウェイトが入力されていません。ウェイトを入力して下さい。'
        );
        return;
      }
      // チャレンジ目標(文字数)
      if (this.chgGoalContent.length > config.ACT_EMT_CONTENT_MAX_LENGTH) {
        this.$refs.dialog.open(
          'info',
          'チャレンジ目標の文字数が多いです。入力文字数を4行程度に短くしてください。'
        );
        return;
      }
      this.deleteFlg = false;
      // 確認ダイアログ表示
      this.confirmMessage = this.challengeGoalTitle + 'を登録しますか？';
      this.$refs.confirm.open();
    },
    delete_confirm() {
      this.deleteFlg = true;
      // 確認ダイアログ表示
      this.confirmMessage = this.challengeGoalTitle + 'を削除しますか？';
      this.$refs.confirm.open();
    },
    editEvaluationInfo() {
      // セッションチェック
      let userInfo = getSessionStorageItem();
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }
      if (!this.deleteFlg) {
        // 登録処理
        if (this.updateFlg) {
          // 更新
          this.makeUpdateGoalInfo();
        } else {
          // 登録
          this.makeInsertGoalInfo();
        }
        this.editEvaluationInfoRequest();
      } else {
        // 削除処理
        this.makeDeleteEvaluationInfo();
        this.deleteEvaluationInfoRequest();
      }
    },
    editEvaluationInfoRequest() {
      // ローディング画像表示
      this.loading = true;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();
      // ウェイトの整形(入力されていない場合は0を設定)
      if (!this.chgGoal1Wekght) {
        this.chgGoal1Wekght = '0';
      }
      if (!this.chgGoal2Wekght) {
        this.chgGoal2Wekght = '0';
      }
      if (!this.chgGoal3Wekght) {
        this.chgGoal3Wekght = '0';
      }
      if (!this.chgGoal4Wekght) {
        this.chgGoal4Wekght = '0';
      }
      // 共通
      this.updateAt = moment().format('YYYYMMDDHHmmss');

      //----- チャレンジ情報更新リクエストPOST
      axios
        .post(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/grade/goal/challenge/update',
          {
            SESSION_ID: userInfo.SESSION_ID,
            SESSION_USER_ID: userInfo.USER_ID,

            GOAL_ID: this.goalId,
            GRADE_ID: this.gradeId,
            CHG_GOAL_1_CONTENT: this.chgGoal1Content,
            CHG_GOAL_1_GOAL_VAL: this.chgGoal1GoalVal,
            CHG_GOAL_1_WEIGHT: this.chgGoal1Wekght,
            CHG_GOAL_2_CONTENT: this.chgGoal2Content,
            CHG_GOAL_2_GOAL_VAL: this.chgGoal2GoalVal,
            CHG_GOAL_2_WEIGHT: this.chgGoal2Wekght,
            CHG_GOAL_3_CONTENT: this.chgGoal3Content,
            CHG_GOAL_3_GOAL_VAL: this.chgGoal3GoalVal,
            CHG_GOAL_3_WEIGHT: this.chgGoal3Wekght,
            CHG_GOAL_4_CONTENT: this.chgGoal4Content,
            CHG_GOAL_4_GOAL_VAL: this.chgGoal4GoalVal,
            CHG_GOAL_4_WEIGHT: this.chgGoal4Wekght,
            UPDATED_AT: this.updateAt,
          }
        )
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            msgStr =
              this.challengeGoalTitle + message.MSG_INFO_GOAL_ENTRY_COMPLETE;
            this.$refs.dialog.open('info', msgStr);
            this.$emit('edit');
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.resolve(true);
      this.dialog = false;
    },
    deleteEvaluationInfoRequest() {
      // ローディング画像表示
      this.loading = true;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();
      // 共通
      this.updateAt = moment().format('YYYYMMDDHHmmss');

      //----- チャレンジ情報更新リクエストPOST
      axios
        .post(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/goal/grade/allchallenge/update',
          {
            SESSION_ID: userInfo.SESSION_ID,
            SESSION_USER_ID: userInfo.USER_ID,

            GOAL_ID: this.goalId,
            GRADE_ID: this.gradeId,
            CHG_GOAL_1_CONTENT: this.chgGoal1Content,
            CHG_GOAL_1_GOAL_VAL: this.chgGoal1GoalVal,
            CHG_GOAL_1_WEIGHT: this.chgGoal1Wekght,
            CHG_GOAL_2_CONTENT: this.chgGoal2Content,
            CHG_GOAL_2_GOAL_VAL: this.chgGoal2GoalVal,
            CHG_GOAL_2_WEIGHT: this.chgGoal2Wekght,
            CHG_GOAL_3_CONTENT: this.chgGoal3Content,
            CHG_GOAL_3_GOAL_VAL: this.chgGoal3GoalVal,
            CHG_GOAL_3_WEIGHT: this.chgGoal3Wekght,
            CHG_GOAL_4_CONTENT: this.chgGoal4Content,
            CHG_GOAL_4_GOAL_VAL: this.chgGoal4GoalVal,
            CHG_GOAL_4_WEIGHT: this.chgGoal4Wekght,

            UPDATED_AT: this.updateAt,
          }
        )
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            msgStr =
              this.challengeGoalTitle + message.MSG_INFO_GOAL_DELETE_COMPLETE;
            this.$refs.dialog.open('info', msgStr);
            this.$emit('edit');
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.resolve(true);
      this.dialog = false;
    },
    async getEvaluationItem() {
      this.loading = true;

      // ユーザ情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/goal/grade/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            this.goalId +
            '/' +
            this.gradeId
        )
        .then((response) => {
          // チャレンジ目標データ取得
          this.chgGoal1Content = response.data[0].CHG_GOAL_1_CONTENT;
          this.chgGoal1GoalVal = response.data[0].CHG_GOAL_1_GOAL_VAL;
          this.chgGoal1Wekght = response.data[0].CHG_GOAL_1_WEIGHT;
          this.chgGoal2Content = response.data[0].CHG_GOAL_2_CONTENT;
          this.chgGoal2GoalVal = response.data[0].CHG_GOAL_2_GOAL_VAL;
          this.chgGoal2Wekght = response.data[0].CHG_GOAL_2_WEIGHT;
          this.chgGoal3Content = response.data[0].CHG_GOAL_3_CONTENT;
          this.chgGoal3GoalVal = response.data[0].CHG_GOAL_3_GOAL_VAL;
          this.chgGoal3Wekght = response.data[0].CHG_GOAL_3_WEIGHT;
          this.chgGoal4Content = response.data[0].CHG_GOAL_4_CONTENT;
          this.chgGoal4GoalVal = response.data[0].CHG_GOAL_4_GOAL_VAL;
          this.chgGoal4Wekght = response.data[0].CHG_GOAL_4_WEIGHT;

          this.chgGoal1GoalVal = response.data[0].CHG_GOAL_1_GOAL_VAL;
          this.chgGoal2GoalVal = response.data[0].CHG_GOAL_2_GOAL_VAL;
          this.chgGoal3GoalVal = response.data[0].CHG_GOAL_3_GOAL_VAL;
          this.chgGoal4GoalVal = response.data[0].CHG_GOAL_4_GOAL_VAL;
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.loading = false;
    },

    makeUpdateGoalInfo() {
      if (this.groupId == this.groupSelect.value) {
        // 表示順が変更になっていない場合
        if (this.groupId == 1) {
          // 表示順1
          this.chgGoal1Content = this.chgGoalContent;
          this.chgGoal1GoalVal = this.chgGoalGoalVal;
          this.chgGoal1Wekght = this.chgGoalWeight;
        } else if (this.groupId == 2) {
          // 表示順2
          this.chgGoal2Content = this.chgGoalContent;
          this.chgGoal2GoalVal = this.chgGoalGoalVal;
          this.chgGoal2Wekght = this.chgGoalWeight;
        } else if (this.groupId == 3) {
          // 表示順3
          this.chgGoal3Content = this.chgGoalContent;
          this.chgGoal3GoalVal = this.chgGoalGoalVal;
          this.chgGoal3Wekght = this.chgGoalWeight;
        } else if (this.groupId == 4) {
          // 表示順4
          this.chgGoal4Content = this.chgGoalContent;
          this.chgGoal4GoalVal = this.chgGoalGoalVal;
          this.chgGoal4Wekght = this.chgGoalWeight;
        }
      } else {
        // 表示順が変更になった場合
        var tmpChgGoalContent = '';
        var tmpChgGoalGoalVal = 0;
        var tmpChgGoalWekght = 0;

        //----- 更新前の値を退避して、更新
        if (this.groupSelect.value == 1) {
          // 表示順1
          tmpChgGoalContent = this.chgGoal1Content;
          tmpChgGoalGoalVal = this.chgGoal1GoalVal;
          tmpChgGoalWekght = this.chgGoal1Wekght;
          this.chgGoal1Content = this.chgGoalContent;
          this.chgGoal1GoalVal = this.chgGoalGoalVal;
          this.chgGoal1Wekght = this.chgGoalWeight;
        } else if (this.groupSelect.value == 2) {
          // 表示順2
          tmpChgGoalContent = this.chgGoal2Content;
          tmpChgGoalGoalVal = this.chgGoal2GoalVal;
          tmpChgGoalWekght = this.chgGoal2Wekght;
          this.chgGoal2Content = this.chgGoalContent;
          this.chgGoal2GoalVal = this.chgGoalGoalVal;
          this.chgGoal2Wekght = this.chgGoalWeight;
        } else if (this.groupSelect.value == 3) {
          // 表示順3
          tmpChgGoalContent = this.chgGoal3Content;
          tmpChgGoalGoalVal = this.chgGoal3GoalVal;
          tmpChgGoalWekght = this.chgGoal3Wekght;
          this.chgGoal3Content = this.chgGoalContent;
          this.chgGoal3GoalVal = this.chgGoalGoalVal;
          this.chgGoal3Wekght = this.chgGoalWeight;
        } else if (this.groupSelect.value == 4) {
          // 表示順4
          tmpChgGoalContent = this.chgGoal4Content;
          tmpChgGoalGoalVal = this.chgGoal4GoalVal;
          tmpChgGoalWekght = this.chgGoal4Wekght;
          this.chgGoal4Content = this.chgGoalContent;
          this.chgGoal4GoalVal = this.chgGoalGoalVal;
          this.chgGoal4Wekght = this.chgGoalWeight;
        }

        //----- 更新前の値を入れ替え
        if (this.groupId == 1) {
          // 表示順1
          this.chgGoal1Content = tmpChgGoalContent;
          this.chgGoal1GoalVal = tmpChgGoalGoalVal;
          this.chgGoal1Wekght = tmpChgGoalWekght;
        } else if (this.groupId == 2) {
          // 表示順2
          this.chgGoal2Content = tmpChgGoalContent;
          this.chgGoal2GoalVal = tmpChgGoalGoalVal;
          this.chgGoal2Wekght = tmpChgGoalWekght;
        } else if (this.groupId == 3) {
          // 表示順3
          this.chgGoal3Content = tmpChgGoalContent;
          this.chgGoal3GoalVal = tmpChgGoalGoalVal;
          this.chgGoal3Wekght = tmpChgGoalWekght;
        } else if (this.groupId == 4) {
          // 表示順4
          this.chgGoal4Content = tmpChgGoalContent;
          this.chgGoal4GoalVal = tmpChgGoalGoalVal;
          this.chgGoal4Wekght = tmpChgGoalWekght;
        }
      }
    },

    makeInsertGoalInfo() {
      // 表示順が変更になった場合
      var tmpChgGoal1Content = this.chgGoal1Content;
      var tmpChgGoal1GoalVal = this.chgGoal1GoalVal;
      var tmpChgGoal1Wekght = this.chgGoal1Wekght;
      var tmpChgGoal2Content = this.chgGoal2Content;
      var tmpChgGoal2GoalVal = this.chgGoal2GoalVal;
      var tmpChgGoal2Wekght = this.chgGoal2Wekght;
      var tmpChgGoal3Content = this.chgGoal3Content;
      var tmpChgGoal3GoalVal = this.chgGoal3GoalVal;
      var tmpChgGoal3Wekght = this.chgGoal3Wekght;
      var tmpChgGoal4Content = this.chgGoal4Content;
      var tmpChgGoal4GoalVal = this.chgGoal4GoalVal;
      var tmpChgGoal4Wekght = this.chgGoal4Wekght;

      if (this.groupSelect.value == 1) {
        // 表示順1
        this.chgGoal1Content = this.chgGoalContent;
        this.chgGoal1GoalVal = this.chgGoalGoalVal;
        this.chgGoal1Wekght = this.chgGoalWeight;
        // 入れ替え
        if (tmpChgGoal1Content != config.GOAL_EMPTY_STRING) {
          // 表示順1 入力済みの場合、入れ替え
          this.chgGoal2Content = tmpChgGoal1Content;
          this.chgGoal2GoalVal = tmpChgGoal1GoalVal;
          this.chgGoal2Wekght = tmpChgGoal1Wekght;
          if (tmpChgGoal2Content != config.GOAL_EMPTY_STRING) {
            // 表示順2 入力済みの場合、入れ替え
            this.chgGoal3Content = tmpChgGoal2Content;
            this.chgGoal3GoalVal = tmpChgGoal2GoalVal;
            this.chgGoal3Wekght = tmpChgGoal2Wekght;
            if (tmpChgGoal3Content != config.GOAL_EMPTY_STRING) {
              // 表示順3 入力済みの場合、入れ替え
              this.chgGoal4Content = tmpChgGoal3Content;
              this.chgGoal4GoalVal = tmpChgGoal3GoalVal;
              this.chgGoal4Wekght = tmpChgGoal3Wekght;
            }
          }
        }
      } else if (this.groupSelect.value == 2) {
        // 表示順2
        this.chgGoal2Content = this.chgGoalContent;
        this.chgGoal2GoalVal = this.chgGoalGoalVal;
        this.chgGoal2Wekght = this.chgGoalWeight;
        // 入れ替え
        if (tmpChgGoal2Content != config.GOAL_EMPTY_STRING) {
          // 表示順2 入力済みの場合、入れ替え
          this.chgGoal3Content = tmpChgGoal2Content;
          this.chgGoal3GoalVal = tmpChgGoal2GoalVal;
          this.chgGoal3Wekght = tmpChgGoal2Wekght;
          if (tmpChgGoal3Content != config.GOAL_EMPTY_STRING) {
            // 表示順3 入力済みの場合、入れ替え
            this.chgGoal4Content = tmpChgGoal3Content;
            this.chgGoal4GoalVal = tmpChgGoal3GoalVal;
            this.chgGoal4Wekght = tmpChgGoal3Wekght;
          }
        }
      } else if (this.groupSelect.value == 3) {
        // 表示順3
        this.chgGoal3Content = this.chgGoalContent;
        this.chgGoal3GoalVal = this.chgGoalGoalVal;
        this.chgGoal3Wekght = this.chgGoalWeight;
        // 入れ替え
        if (tmpChgGoal3Content != config.GOAL_EMPTY_STRING) {
          // 表示順3 入力済みの場合、入れ替え
          this.chgGoal4Content = tmpChgGoal3Content;
          this.chgGoal4GoalVal = tmpChgGoal3GoalVal;
          this.chgGoal4Wekght = tmpChgGoal3Wekght;
        }
      } else if (this.groupSelect.value == 4) {
        // 表示順4
        this.chgGoal4Content = this.chgGoalContent;
        this.chgGoal4GoalVal = this.chgGoalGoalVal;
        this.chgGoal4Wekght = this.chgGoalWeight;
        // 入れ替え
        if (tmpChgGoal4Content != config.GOAL_EMPTY_STRING) {
          // 表示順4 入力済みの場合、入れ替え
          this.chgGoal3Content = tmpChgGoal4Content;
          this.chgGoal3GoalVal = tmpChgGoal4GoalVal;
          this.chgGoal3Wekght = tmpChgGoal4Wekght;
          if (tmpChgGoal3Content != config.GOAL_EMPTY_STRING) {
            // 表示順3 入力済みの場合、入れ替え
            this.chgGoal2Content = tmpChgGoal3Content;
            this.chgGoal2GoalVal = tmpChgGoal3GoalVal;
            this.chgGoal2Wekght = tmpChgGoal3Wekght;
            if (tmpChgGoal2Content != config.GOAL_EMPTY_STRING) {
              // 表示順2 入力済みの場合、入れ替え
              this.chgGoal1Content = tmpChgGoal2Content;
              this.chgGoal1GoalVal = tmpChgGoal2GoalVal;
              this.chgGoal1Wekght = tmpChgGoal2Wekght;
            }
          }
        }
      }
    },

    makeDeleteEvaluationInfo() {
      // チャレンジ目標の削除を行うデータを作成
      if (this.groupId == 1) {
        // チャレンジ目標1の削除
        this.chgGoal1Content = this.chgGoal2Content;
        this.chgGoal1GoalVal = this.chgGoal2GoalVal;
        this.chgGoal1Wekght = this.chgGoal2Wekght;
        this.chgGoal2Content = this.chgGoal3Content;
        this.chgGoal2GoalVal = this.chgGoal3GoalVal;
        this.chgGoal2Wekght = this.chgGoal3Wekght;
        this.chgGoal3Content = this.chgGoal4Content;
        this.chgGoal3GoalVal = this.chgGoal4GoalVal;
        this.chgGoal3Wekght = this.chgGoal4Wekght;
        this.chgGoal4Content = config.GOAL_EMPTY_STRING;
        this.chgGoal4GoalVal = 0;
        this.chgGoal4Wekght = 0;
      } else if (this.groupId == 2) {
        // チャレンジ目標2の削除
        this.chgGoal2Content = this.chgGoal3Content;
        this.chgGoal2GoalVal = this.chgGoal3GoalVal;
        this.chgGoal2Wekght = this.chgGoal3Wekght;
        this.chgGoal3Content = this.chgGoal4Content;
        this.chgGoal3GoalVal = this.chgGoal4GoalVal;
        this.chgGoal3Wekght = this.chgGoal4Wekght;
        this.chgGoal4Content = config.GOAL_EMPTY_STRING;
        this.chgGoal4GoalVal = 0;
        this.chgGoal4Wekght = 0;
      } else if (this.groupId == 3) {
        // チャレンジ目標3の削除
        this.chgGoal3Content = this.chgGoal4Content;
        this.chgGoal3GoalVal = this.chgGoal4GoalVal;
        this.chgGoal3Wekght = this.chgGoal4Wekght;
        this.chgGoal4Content = config.GOAL_EMPTY_STRING;
        this.chgGoal4GoalVal = 0;
        this.chgGoal4Wekght = 0;
      } else if (this.groupId == 4) {
        // チャレンジ目標4の削除
        this.chgGoal4Content = config.GOAL_EMPTY_STRING;
        this.chgGoal4GoalVal = 0;
        this.chgGoal4Wekght = 0;
      }
    },

    cancel() {
      this.dialog = false;
    },

    async regist() {
      this.dialog = false;
    },
  },
};
</script>
<style>
.ql-container {
  background-color: white;
  font-size: 16px;
}
.ql-toolbar {
  display: block;
  background-color: #f5f5f5;
}
</style>
